import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Heading for a truck's job card. /api/gps/locations/current returns the
// in-progress stop when someone is clocked in, otherwise the next stop on
// the route, so the heading has to say which one it is.
export const truckJobHeadingKey = (truck) => {
  if (truck?.current_job_id) {
    return truck.job_in_progress ? 'liveTracking.currentJob' : 'liveTracking.nextJob';
  }
  return 'liveTracking.currentJob';
};

// Job lines for the Live Tracking truck list and truck details modal:
// the current/next stop plus the stop the crew last clocked out of today.
const TruckJobSummary = ({ truck }) => {
  const { t, i18n } = useTranslation();
  if (!truck) return null;

  const lastFinishedTime = truck.last_job_clock_out
    ? new Date(truck.last_job_clock_out).toLocaleTimeString(i18n.language, {
      hour: 'numeric',
      minute: '2-digit',
    })
    : null;

  return (
    <Box>
      {truck.current_job_id ? (
        <>
          <Typography variant="body2">
            {t('liveTracking.jobNumber', { number: truck.job_number })}
          </Typography>
          {truck.customer_display_name && (
            <Typography variant="body2" color="textSecondary">
              {truck.customer_display_name}
            </Typography>
          )}
          {truck.job_address && (
            <Typography variant="caption" display="block" color="textSecondary">
              {[truck.job_address, truck.job_city].filter(Boolean).join(', ')}
            </Typography>
          )}
        </>
      ) : (
        <Typography variant="body2" color="textSecondary">
          {t('liveTracking.noActiveJob')}
        </Typography>
      )}
      {truck.last_job_number && lastFinishedTime && (
        <Typography variant="caption" display="block" color="textSecondary" sx={{ mt: 1 }}>
          {t('liveTracking.lastFinished', {
            name: [truck.last_customer_display_name || truck.last_job_number, truck.last_job_address]
              .filter(Boolean)
              .join(', '),
            time: lastFinishedTime,
          })}
        </Typography>
      )}
    </Box>
  );
};

export default TruckJobSummary;
